import { DownloadBlob } from '@browser/Browser';
import * as rt from "@common/AppRT";
import { numCompare } from "@common/Common";
import PortfolioNavigation from "@common/Components/PortfolioNavigation.vue";
import DisagreementsReportDialog from "@Evaluation/AlternativesSurveys/Components/DisagreementsReportDialog.vue";
import MeetingQuestionReview from "@Evaluation/AlternativesSurveys/Components/MeetingQuestionReview.vue";
import MeetingStarterDialog from "@Evaluation/AlternativesSurveys/Components/MeetingStarterDialog.vue";
import MeetingStopperDialog from "@Evaluation/AlternativesSurveys/Components/MeetingStopperDialog.vue";
import PanelConsistencyAnalysisDialog from "@Evaluation/AlternativesSurveys/Components/PanelConsistencyAnalysisDialog.vue";
import { ScoringSurveyAccessLinksViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyAccessLinks';
import ScoringSurveyAccessLinks from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyAccessLinks.vue';
import { ScoringSurveyEmailSenderViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyEmailSender';
import ScoringSurveyEmailSender from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyEmailSender.vue';
import SurveyCloserDialog from "@Evaluation/AlternativesSurveys/Components/SurveyCloserDialog.vue";
import SurveyOpenerDialog from "@Evaluation/AlternativesSurveys/Components/SurveyOpenerDialog.vue";
import { SavePanelVoteCommandV1, SendEmailCommandV1, StartSurveyCommandV1, StopSurveyCommandV1 } from "@Evaluation/AlternativesSurveys/Domain/commands-core";
import ScoringCommands from '@Evaluation/AlternativesSurveys/Domain/commands-vue-component';
import ScoringQueries from '@Evaluation/AlternativesSurveys/Domain/queries-vue-component';
import { MeetingManagerPageReadModel, MeetingManagerQuestionReadModel, MeetingQuestionReviewReadModel, PanelConsistencyAnalysisReadModel, PanelDisagreementsReportReadModel, ScoringAlternativeReadModel, ScoringCriterionReadModel, ScoringDownloadAccessLinksReadModel, ScoringSurveyPanelistsReadModel } from '@Evaluation/AlternativesSurveys/Domain/readmodels';
import { IEvaluationCommand } from "@Evaluation/cqrs";
import { QuestionsOrder, SurveyVoteStatus } from "@Evaluation/Model";
import Component, { mixins } from 'vue-class-component';


@Component({
    components: {
        PortfolioNavigation, SurveyOpenerDialog, SurveyCloserDialog, MeetingStarterDialog, MeetingStopperDialog, DisagreementsReportDialog,
        PanelConsistencyAnalysisDialog, MeetingQuestionReview, ScoringSurveyAccessLinks, ScoringSurveyEmailSender
    }
})
export default class MeetingManagerPage extends mixins(ScoringCommands, ScoringQueries)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get projectId() { return Number.parseInt(this.$route.params.projectId); }
    get evalModelId() { return Number.parseInt(this.$route.params.evalModelId); }
    get surveyId(): number { return Number.parseInt(this.$route.params.surveyId); }

    handler: any = null;
    SavingCommentHandle: any = null;
    SwitchQuestionDebounceHandle: any = null;
    Initialized: boolean = false;
    CurrentQuestionIndex: number = 0;
    Description: string;

    QuestionsOrder: QuestionsOrder = QuestionsOrder.ByAlternatives;
    Questions: MeetingManagerQuestionReadModel[] = [];

    AutoRevealEnabled: boolean = false;
    NamesRevealed: boolean = true;
    VotesRevealed: boolean = false;
    SearchPhrase: string = null;
    MeetingStarted: boolean = false;

    surveyOpenerOpened: boolean = false;
    surveyCloserOpened: boolean = false;
    meetingStarterOpened: boolean = false;
    meetingStopperOpened: boolean = false;
    disagreementsReportOpened: boolean = false;
    consistencyAnalysisOpened: boolean = false;
    scoringSurveyAccessLinks = new ScoringSurveyAccessLinksViewModel();
    scoringSurveyEmailSender = new ScoringSurveyEmailSenderViewModel();

    rm: MeetingManagerPageReadModel | null = null;
    get surveyName(): string { return this.rm.SurveyName; }
    get surveyQuestionsCount(): number { return this.rm.SurveyQuestionsCount; }
    get surveyStarted(): boolean { return this.rm?.SurveyStarted; }
    get disagreementReport(): PanelDisagreementsReportReadModel { return this.rm?.DisagreementReport; }
    get consistencyAnalysis(): PanelConsistencyAnalysisReadModel { return this.rm?.ConsistencyAnalysis; }

    get Question(): MeetingQuestionReviewReadModel { return this.rm?.Question; }

    get CurrentQuestionInfo(): MeetingManagerQuestionReadModel { return this.Questions[this.CurrentQuestionIndex]; }
    get CurrentContext(): ScoringCriterionReadModel { return this.rm.Criteria.find(c => c.Id === this.CurrentQuestionInfo?.CriterionId); }
    get CurrentAlternative(): ScoringAlternativeReadModel { return this.rm.Alternatives.find(a => a.Id === this.CurrentQuestionInfo?.ContextAlternativeId); }

    get QuestionsOrderLabel(): string { return this.QuestionsOrder === QuestionsOrder.ByAlternatives ? "By alternative" : "By criterion"; }
    get AnsweredQuestionsCount(): number { return this.Questions.filter(a => a.IsDuplicate === false && a.AnswerStatus !== SurveyVoteStatus.Empty).length; }

    get EvalContextsView(): ScoringCriterionReadModel[]
    {
        const phrase = this.SearchPhrase?.toLowerCase() ?? "";
        return this.rm.Criteria.filter(o => o.Path.toLowerCase().indexOf(phrase) >= 0);
    }

    get EvalAlternativesView(): ScoringAlternativeReadModel[]
    {
        const phrase = this.SearchPhrase?.toLowerCase() ?? "";
        return this.rm.Alternatives.filter(o => o.Name.toLowerCase().indexOf(phrase) >= 0);
    }

    get ByAlternativeQuestionsView(): MeetingManagerQuestionReadModel[] 
    {
        return this.Questions.filter(q => q.ContextAlternativeId === this.CurrentQuestionInfo?.ContextAlternativeId);
    }

    get ByContextQuestionsView(): MeetingManagerQuestionReadModel[] 
    {
        return this.Questions.filter(q => q.CriterionId === this.CurrentQuestionInfo?.CriterionId);
    }


    getQuestionCssClass(q: MeetingManagerQuestionReadModel)
    {
        switch (q.AnswerStatus)
        {
            case SurveyVoteStatus.Empty:
                return 'fa fa-question-circle fg-color-red';
            case SurveyVoteStatus.Agg:
                return 'fa fa-check-circle fg-color-green';
            case SurveyVoteStatus.Manual:
                return 'fa fa-check-circle fg-color-orange';
            default:
                return 'fa'; // default fa class if needed
        }
    }

    SetQuestionStatus(questionId: number, status: SurveyVoteStatus)
    {
        //Pairwise duplicate           
        this.Questions.filter(a => a.Id === questionId).forEach(a => a.AnswerStatus = status);
    }


    SwitchQuestionsOrder()
    {
        if (this.QuestionsOrder === QuestionsOrder.ByCriteria)
        {
            const currIndex = this.CurrentQuestionInfo.OrderValueByAlternative;

            this.QuestionsOrder = QuestionsOrder.ByAlternatives;
            this.Questions = this.rm.Questions.sort((a, b) => numCompare(a.OrderValueByAlternative, b.OrderValueByAlternative));
            this.CurrentQuestionIndex = currIndex;
        }
        else
        {
            const currIndex = this.CurrentQuestionInfo.OrderValueByCriterion;

            this.QuestionsOrder = QuestionsOrder.ByCriteria;
            this.Questions = this.rm.Questions.filter(a => a.IsDuplicate === false).sort((a, b) => numCompare(a.OrderValueByCriterion, b.OrderValueByCriterion));
            this.CurrentQuestionIndex = currIndex;
        }
    }

    SetCurrentContext(criterionId: number)
    {
        this.CurrentQuestionIndex = this.Questions.findIndex(a => a.CriterionId === criterionId);
    }

    SetCurrentAlternative(alternativeId: string)
    {
        this.CurrentQuestionIndex = this.Questions.findIndex(a => a.ContextAlternativeId === alternativeId);
    }

    SwitchQuestion(questionId: number)
    {
        this.VotesRevealed = this.AutoRevealEnabled;
        this.CurrentQuestionIndex = this.Questions.findIndex(a => a.Id === questionId);

        this.runMeetingQuestionReviewQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId, questionId);
    }

    NextQuestionCommand()
    {
        if (this.SwitchQuestionDebounceHandle == null)
        {
            this.CurrentQuestionIndex = this.CurrentQuestionIndex < this.Questions.length - 1 ? this.CurrentQuestionIndex + 1 : 0;

            this.SwitchQuestionDebounceHandle = setTimeout(() =>
            {
                clearTimeout(this.SwitchQuestionDebounceHandle);
                this.SwitchQuestionDebounceHandle = null;
            }, 600);
        }
    }

    NextUnansweredQuestionCommand()
    {
        if (this.SwitchQuestionDebounceHandle == null)
        {
            //let questions = this.OrderValues.filter((q, i) => i > this.Page.CurrentQuestionOrderValue && q[1].HasVote === false);

            //if (questions.length === 0)
            //{
            //    questions = this.OrderValues.filter((q, i) => i < this.Page.CurrentQuestionOrderValue && q[1].HasVote === false);
            //}

            //if (questions.length > 0)
            //{
            //    this.Page.SetCurrentAlternative(questions[0][0]);
            //    this.SwitchQuestion(questions[0][1].QuestionId);
            //}

            this.SwitchQuestionDebounceHandle = setTimeout(() =>
            {
                clearTimeout(this.SwitchQuestionDebounceHandle);
                this.SwitchQuestionDebounceHandle = null;
            }, 600);
        }
    }

    PreviousQuestionCommand()
    {
        if (this.SwitchQuestionDebounceHandle == null)
        {
            this.CurrentQuestionIndex = this.CurrentQuestionIndex > 0 ? this.CurrentQuestionIndex - 1 : this.Questions.length - 1;

            this.SwitchQuestionDebounceHandle = setTimeout(() =>
            {
                clearTimeout(this.SwitchQuestionDebounceHandle);
                this.SwitchQuestionDebounceHandle = null;
            }, 600);
        }
    }

    AllDoneCommand()
    {
        alert("Thanks! There are no other unanswered questions. You can close this page or continue reviewing your input.");
    }

    handleShowDisagreementsQuestion(questionId: number)
    {
        this.SwitchQuestion(questionId);
        this.disagreementsReportOpened = false;
    }

    handleShowInconsistentQuestion(questionId: number)
    {
        this.SwitchQuestion(questionId);
        this.consistencyAnalysisOpened = false;
    }


    SetVotesBrowserValue(questionId: number, projectUserId: number, value: number | null)
    {
        if (this.CurrentQuestionInfo.Id === questionId)
        {
            this.Question.VotesEntries.find(a => a.ProjectUserId).Value = value;

            if (this.Question.VotesEntries.some(v => v.Value != null))
            {
                if (this.CurrentQuestionInfo.AnswerStatus === SurveyVoteStatus.Empty)
                {
                    this.CurrentQuestionInfo.AnswerStatus = SurveyVoteStatus.Agg;
                }
            }
            else
            {
                if (this.CurrentQuestionInfo.AnswerStatus === SurveyVoteStatus.Agg)
                {
                    this.CurrentQuestionInfo.AnswerStatus = SurveyVoteStatus.Empty;
                }
            }

            this.publishPanelistVote(projectUserId, questionId);
        }
    }

    SetVotesBrowserComment(questionId: number, projectUserId: number, comment: string)
    {
        if (this.CurrentQuestionInfo.Id === questionId)
        {
            this.Question.VotesEntries.find(a => a.ProjectUserId).Comment = comment;
            this.publishPanelistVote(projectUserId, questionId);
        }
    }


    UpdateNamesRevealed()
    {
        rt.send("Evaluation.ScoringMeetingManager", "UpdateNamesRevealed",
            {
                SurveyId: this.surveyId,
                QuestionId: this.CurrentQuestionInfo.Id,
                NamesRevealed: this.NamesRevealed,
                VotesRevealed: this.VotesRevealed
            });
    }

    UpdateVotesRevealed()
    {
        rt.send("Evaluation.ScoringMeetingManager", "UpdateVotesRevealed",
            {
                SurveyId: this.surveyId,
                QuestionId: this.CurrentQuestionInfo.Id,
                NamesRevealed: this.NamesRevealed,
                VotesRevealed: this.VotesRevealed
            });
    }


    showMeetingStarter()
    {
        this.VotesRevealed = false;
        this.AutoRevealEnabled = false;
        this.NamesRevealed = true;

        this.meetingStarterOpened = true;
    }

    ShowAccessLinksCommand()
    {
        this.scoringSurveyAccessLinks.show(this.surveyId);
        this.runScoringAccessLinksBySurveyIdQueryV1(this.workspaceId, this.surveyId);
    }

    showDisagreementsReport()
    {
        this.rm.DisagreementReport = null;
        this.disagreementsReportOpened = true;
        this.runPanelDisagreementsQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    showConsistencyAnalysis()
    {
        this.rm.ConsistencyAnalysis = null;
        this.consistencyAnalysisOpened = true;
        this.runPanelConsistencyAnalysisQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }


    ToggleAutoRevealCommand()
    {
        this.AutoRevealEnabled = !this.AutoRevealEnabled;

        if (this.AutoRevealEnabled && !this.VotesRevealed)
        {
            this.VotesRevealed = true;
            this.publishQuestionVotes();
        }
    }

    ToggleNamesRevealedCommand()
    {
        this.NamesRevealed = !this.NamesRevealed;
        this.publishQuestionVotes();
    }

    ToggleVotesRevealedCommand()
    {
        this.VotesRevealed = !this.VotesRevealed;

        if (!this.VotesRevealed && this.AutoRevealEnabled)
        {
            this.AutoRevealEnabled = false;
        }

        this.publishQuestionVotes();
    }


    handleStopMeetingCommand() 
    {
        this.MeetingStarted = false;
        this.publishMeetingStatus();
        this.meetingStopperOpened = false;
    }

    handleStartMeetingCommand() 
    {
        this.VotesRevealed = this.AutoRevealEnabled;
        this.MeetingStarted = true;
        this.publishMeetingStatus();
        this.meetingStarterOpened = false;
    }

    handleShowEmailSender(surveyId: number, puIds: number[])
    {
        this.scoringSurveyEmailSender.show(surveyId, puIds);
    }

    handleSendEmailCommand(emailSubject: string, emailBody: string)
    {
        const sender = this.scoringSurveyEmailSender;
        this.invokeSendEmailCommandV1(this.workspaceId, this.surveyId, sender.projectUserIds, emailSubject, emailBody);
    }

    handleDownloadAccessLinks(surveyId: number)
    {
        this.runExportScoringAccessLinksBySurveyIdQueryV1(this.workspaceId, surveyId);
    }


    handleStopSurveyCommand() 
    {
        this.invokeStopSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    handleStartSurveyCommand() 
    {
        this.invokeStartSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    handleSavePanelVoteCommand(value: number)
    {
        this.Question.Value = value;
        this.invokeSavePanelVoteCommandV1(this.workspaceId, this.surveyId, this.Question.Id, this.Question.Value, this.Question.Comment);
    }

    handleSavePanelVoteCommentCommand(comment: string)
    {
        this.Question.Comment = comment;

        if (this.SavingCommentHandle == null)
        {
            this.SavingCommentHandle = setTimeout(() =>
            {
                this.invokeSavePanelVoteCommentCommandV1(this.workspaceId, this.surveyId, this.Question.Id, this.Question.Comment);
                this.SavingCommentHandle = null;
            }, 1000);
        }
    }


    mounted()
    {
        //document.title = "Panelists | TransparentChoice";

        this.handler = rt.subscribeModule("AlternativesSurveys.MeetingManager",
            {
                PublishMeetingStatus: (data: any) =>
                {
                    if (this != null)
                    {
                        this.publishMeetingStatus();
                    }
                },
                UpdatePanelistVoteValue: (data: any) =>
                {
                    if (this != null)
                    {
                        this.SetVotesBrowserValue(data.QuestionId, data.ProjectUserId, data.Value);
                        this.publishPanelistVote(data.ProjectUserId, data.QuestionId);
                    }
                },
                UpdatePanelistVoteComment: (data: any) =>
                {
                    if (this != null)
                    {
                        this.SetVotesBrowserComment(data.QuestionId, data.ProjectUserId, data.Comment);
                        this.publishPanelistVote(data.ProjectUserId, data.QuestionId);
                    }
                },
            });

        this.runMeetingManagerPageQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "MeetingManagerPageReadModel")
        {
            this.rm = model as MeetingManagerPageReadModel;
            this.QuestionsOrder = QuestionsOrder.ByAlternatives;
            this.Questions = this.rm.Questions.sort((a, b) => numCompare(a.OrderValueByAlternative, b.OrderValueByAlternative));
            this.Initialized = true;
        }
        else if (modelName == "MeetingQuestionReviewReadModel")
        {
            this.rm.Question = model as MeetingQuestionReviewReadModel;
            this.publishQuestion();
        }
        else if (modelName == "PanelDisagreementsReportReadModel")
        {
            this.rm.DisagreementReport = model as PanelDisagreementsReportReadModel;
        }
        else if (modelName == "PanelConsistencyAnalysisReadModel")
        {
            this.rm.ConsistencyAnalysis = model as PanelConsistencyAnalysisReadModel;
        }
        else if (modelName == "ScoringSurveyPanelistsReadModel")
        {
            const rm = model as ScoringSurveyPanelistsReadModel;
            this.scoringSurveyAccessLinks.setData(rm);
        }
        else if (modelName === "ScoringDownloadAccessLinksReadModel")
        {
            const rm = model as ScoringDownloadAccessLinksReadModel;
            DownloadBlob(rm.Url);
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string, result: any)
    {
        if (StartSurveyCommandV1.matchType(cmd))
        {
            this.rm.SurveyStarted = true;
            this.surveyOpenerOpened = false;
        }
        else if (StopSurveyCommandV1.matchType(cmd))
        {
            this.rm.SurveyStarted = false;
            this.surveyCloserOpened = false;
        }
        else if (SavePanelVoteCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as SavePanelVoteCommandV1;

            if (this.Question.Id === cmd1.QuestionId)
            {
                const q = this.rm.Questions.find(a => a.Id === this.Question.Id);

                if (cmd1.VoteValue != null)
                {
                    q.AnswerStatus = SurveyVoteStatus.Manual;
                }
                else if (this.Question.VotesEntries.some(a => a.Value != null)) 
                {
                    q.AnswerStatus = SurveyVoteStatus.Agg;
                }
                else
                {
                    q.AnswerStatus = SurveyVoteStatus.Empty;
                }
            }
        }
        else if (SendEmailCommandV1.matchType(cmd))
        {
            alert("Sent");
            this.scoringSurveyEmailSender.close();
        }
    }

    publishMeetingStatus()
    {
        if (this.MeetingStarted === true)
        {
            rt.send("AlternativesSurveys.MeetingManager", "PublishMeetingStarted",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    Question: this.Question,
                    NamesRevealed: this.NamesRevealed,
                    VotesRevealed: this.VotesRevealed
                });
        }

        if (this.MeetingStarted === false)
        {
            rt.send("AlternativesSurveys.MeetingManager", "PublishMeetingStopped",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                });
        }
    }

    publishQuestion()
    {
        if (this.MeetingStarted === true)
        {
            rt.send("AlternativesSurveys.MeetingManager", "PublishMeetingQuestion",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    Question: this.Question,
                    NamesRevealed: this.NamesRevealed,
                    VotesRevealed: this.VotesRevealed
                });
        }
    }

    publishQuestionVotes()
    {
        if (this.MeetingStarted === true)
        {
            rt.send("AlternativesSurveys.MeetingManager", "PublishMeetingQuestionVotes",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    Question: this.Question,
                    NamesRevealed: this.NamesRevealed,
                    VotesRevealed: this.VotesRevealed
                });
        }
    }

    publishPanelistVote(projectUserId: number, questionId: number)
    {
        if (this.MeetingStarted === true && this.VotesRevealed === true && this.Question.Id === questionId)
        {
            const vote = this.Question.VotesEntries.find(a => a.ProjectUserId === projectUserId);

            rt.send("AlternativesSurveys.MeetingManager", "PublishMeetingPanelistVote",
                {
                    WorkspaceId: this.workspaceId,
                    SurveyId: this.surveyId,
                    ProjectUserId: projectUserId,
                    QuestionId: questionId,
                    VoteValue: vote?.Value,
                    VoteComment: vote?.Comment,
                });
        }
    }

    beforeDestroy()
    {
        if (this.handler)
        {
            rt.unsubscribe(this.handler);
        }
    }
}